import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import UserSection from "../../Services/User/UserLogin";
import handleApiError from "../../Helpers/handleApiError";
import Carousel from "../Carousel";

import img1 from "../../../src/SliderImage/1.jpg";
import img3 from "../../../src/SliderImage/3.jpg";
import img4 from "../../../src/SliderImage/4.jpg";
import img5 from "../../../src/SliderImage/5.jpg";
import img6 from "../../../src/SliderImage/6.jpg";
import img7 from "../../../src/SliderImage/7.jpg";
import img8 from "../../../src/SliderImage/8.jpg";
import grohe from "../../../src/clientlogo/index_grohe_logo.jpg";
import americanStandard from "../../../src/clientlogo/index_as_logo.gif";
import lixil from "../../../src/clientlogo/index_lixil_logo.gif";
import NoticeMirage from "../utils/NoticeMirage";

export default function UserLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const images = [img1, img3, img4, img5, img6, img7, img8];
  const clientLogos = [
    { src: grohe, alt: "Grohe" },
    { src: americanStandard, alt: "American Standard" },
    { src: lixil, alt: "Lixil" },
  ];

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await UserSection.userLogin({ email, password });

      if (
        response.status &&
        [2, 3, 4, 5, 6, 7, 8].includes(response.data.data.role_id) &&
        response.data.data.is_active == 1
      ) {

        localStorage.setItem("u_token", response.data.token);
        localStorage.setItem("user_name", response.data.data.name);
        localStorage.setItem("role_code", response.data.data.role_id);
        Swal.fire({
          icon: "success",
          title: "Login",
          text: `Welcome ${response.data.data.name}`,
          timer: 1000,
        });
        // window.location.href = "/user";
        // navigate("/user");
      } else {
        Swal.fire(
          "Permission Denied",
          "You do not have the right access.",
          "warning"
        );
        navigate("/");
      }
    } catch (error) {
      if (error.response?.data?.attempt > 4) {
        navigate("/forgotPassword");
        Swal.fire({
          icon: "warning",
          title: "Too many attempts",
          text: `Reset your password to continue browsing`,
        });
      } else {
        handleApiError(error, "Login failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const token_check = localStorage.getItem("u_token");
  const role_check = Number(localStorage.getItem("role_code"));

  useEffect(() => {
    if (token_check) {
      if (role_check == 1) {
        window.location.href = "/admin/login";
      } else if ([2, 3, 4,5,6, 7, 8].includes(role_check)) {
        window.location.href = "/user";
      } else {
        console.log('INALID USER');
      }
    }
  }, [token_check, role_check]);

  return (
    <>
      <NoticeMirage />
      <div className="min-h-screen flex items-center justify-end relative overflow-hidden bg-[#050b14] font-['Inter',system-ui,sans-serif]">
        
        {/* Background Carousel - Completely clear without any overlays */}
        <div className="absolute inset-0 z-0">
          <Carousel images={images} />
        </div>

        {/* Top Left Logos (Floating, elegantly integrated) */}
        <div className="absolute top-8 left-8 z-20 flex flex-col gap-4">
          <div className="flex gap-4 items-center bg-white/10 backdrop-blur-md p-3.5 rounded-2xl border border-white/20 shadow-lg">
            {clientLogos.slice(0, 2).map((logo, index) => (
              <div key={index} className="px-4 py-1.5 bg-white/20 hover:bg-white/30 transition duration-300 rounded-xl flex items-center justify-center">
                <img src={logo.src} alt={logo.alt} className="w-20 h-10 object-contain drop-shadow-lg" />
              </div>
            ))}
          </div>
          <div className="flex items-center pl-3 opacity-90 drop-shadow-md">
            <span className="text-white text-xs font-semibold tracking-[0.2em] mr-4 drop-shadow-[0_2px_2px_rgba(0,0,0,0.8)]">PART OF</span>
            <span className="bg-gradient-to-r from-orange-500 to-amber-500 text-white px-2.5 py-0.5 rounded text-[10px] font-black tracking-widest shadow-lg">LIXIL</span>
          </div>
        </div>

        {/* Login Card - Floating Glassmorphic Integrated Design */}
        <div className="w-[90%] sm:w-[420px] relative z-10 lg:mr-24 xl:mr-32 group">
          
          <div className="relative bg-white/10 backdrop-blur-2xl border border-white/30 rounded-[2rem] shadow-[0_15px_50px_0_rgba(0,0,0,0.3)] p-10 overflow-hidden">
            {/* Soft inner glow */}
            <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent opacity-50"></div>

            <div className="text-left mb-10 relative z-10">
              <h2 className="text-4xl font-semibold text-white tracking-tight mb-2 drop-shadow-lg">Welcome.</h2>
              <p className="text-white/80 text-sm tracking-wide font-medium drop-shadow-md">Sign in to your user account</p>
            </div>
            
            <form onSubmit={handleLogin} className="space-y-6 relative z-10">
              <div className="relative">
                <label 
                  htmlFor="email" 
                  className="block text-white/90 text-xs font-bold mb-2 tracking-widest uppercase drop-shadow-md"
                >
                  Email Address
                </label>
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  id="email"
                  name="email"
                  type="email"
                  required
                  className="w-full px-5 py-4 text-sm rounded-xl bg-black/20 border border-white/20 focus:border-white/50 focus:bg-black/30 focus:ring-2 focus:ring-white/20 text-white outline-none transition-all duration-300 placeholder-white/40 shadow-inner backdrop-blur-md"
                  placeholder="name@company.com"
                />
              </div>

              <div>
                <div className="relative">
                  <label 
                    htmlFor="password" 
                    className="block text-white/90 text-xs font-bold mb-2 tracking-widest uppercase drop-shadow-md"
                  >
                    Password
                  </label>
                  <input
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    id="password"
                    name="password"
                    type="password"
                    required
                    className="w-full px-5 py-4 text-sm rounded-xl bg-black/20 border border-white/20 focus:border-white/50 focus:bg-black/30 focus:ring-2 focus:ring-white/20 text-white outline-none transition-all duration-300 placeholder-white/40 shadow-inner backdrop-blur-md"
                    placeholder="••••••••"
                  />
                </div>
                <div className="text-right mt-3">
                  <Link
                    to="/forgotPassword"
                    className="text-xs text-white/80 font-medium hover:text-white transition-colors duration-200 drop-shadow-sm tracking-wide"
                  >
                    Forgot your password?
                  </Link>
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full py-4 mt-2 bg-white/20 hover:bg-white/30 border border-white/40 text-white font-bold tracking-widest rounded-xl shadow-[0_8px_20px_rgba(0,0,0,0.2)] hover:shadow-[0_12px_25px_rgba(0,0,0,0.3)] transition-all duration-300 transform hover:-translate-y-0.5 disabled:opacity-70 disabled:hover:translate-y-0 flex items-center justify-center gap-2 backdrop-blur-lg"
              >
                {loading ? (
                  <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                ) : 'SIGN IN'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
